import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BackupService {

    backups: any = {};

    backup(key: string, object: any): void {
        this.backups[key] = JSON.parse(JSON.stringify(object));
    }

    reset(key: string, object: any): any {
        for (const property in this.backups[key]) {
            if (this.backups[key].hasOwnProperty(property)) {
                object[property] = this.backups[key][property];
            }
        }

        delete this.backups[key];
        return object;
    }
}
